// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
export const paths: string[] = [
  'M2.75 3.5V12.5M8.5 3.5V12.5M2.75 8H8.5',
  'M14 6.75H11V9.25H12.15C13.3 9.25 14.1 9.9 14.1 10.9C14.1 12.5 12.15 12.95 10.9 12.05',
];
